export const QR_SIGNIN_MODAL_QUERY_PARAM_NAME = 'signinModal';
export const QR_SIGNIN_MODAL_QUERY_PARAM_HMAC = 'hmac';
export const QR_SIGNIN_MODAL_QUERY_PARAM_SITEID = 'siteId';
export const QR_SIGNIN_MODAL_QUERY_PARAM_KEY = 'key';
